import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { motion } from "framer-motion";
import { useScrollAnimation } from "@/hooks/use-scroll-animation";

const faqs = [
  {
    q: "Hvad er MySabbat?",
    a: "MySabbat er en app der hjælper unge med at planlægge og navigere deres sabbatår. Vi samler job, rejser, højskoler og planlægningsværktøjer ét sted.",
  },
  {
    q: "Hvem er appen for?",
    a: "MySabbat er lavet til unge i Danmark der overvejer eller planlægger sabbatår — uanset om du vil rejse, arbejde, gå på højskole eller bare finde retning.",
  },
  {
    q: "Hvad kan man bruge den til?",
    a: "Du kan finde job og frivilligt arbejde, udforske rejsemuligheder, sammenligne højskoler, planlægge dit budget og holde styr på deadlines og mål.",
  },
  {
    q: "Koster det noget?",
    a: "MySabbat Pro Monthly koster 39 kr/måned. MySabbat Pro Yearly koster 349 kr/år og inkluderer ekstra premium-funktioner.",
  },
  {
    q: "Hvordan kommer jeg i gang?",
    a: "Download MySabbat på App Store og opret din konto – så er du i gang på få minutter. Android-versionen kommer senere.",
  },
];

const FAQSection = () => {
  const { ref, isVisible } = useScrollAnimation(0.1);

  return (
    <section className="py-20 md:py-28 section-gradient-cool" ref={ref}>
      <div className="container max-w-2xl">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={isVisible ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <h2 className="text-heading md:text-display-sm text-foreground mb-4">
            Ofte stillede spørgsmål
          </h2>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 16 }}
          animate={isVisible ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.5, delay: 0.15 }}
        >
          <Accordion type="single" collapsible className="space-y-3">
            {faqs.map((faq, i) => (
              <AccordionItem
                key={i}
                value={`faq-${i}`}
                className="glass-card rounded-xl px-5 border-none"
              >
                <AccordionTrigger className="text-left text-foreground font-medium hover:no-underline py-4">
                  {faq.q}
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground pb-4 leading-relaxed">
                  {faq.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </motion.div>
      </div>
    </section>
  );
};

export default FAQSection;
